<template>
  <div>
    <video ref="videoPlayer" class="video-js" crossorigin="anonymous"></video>
    <button @click="changePanoramic">Change Panoramic</button>
  </div>
</template>

<script>
import videojs from 'video.js';
import {} from 'videojs-vr';

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      player: null,
      projection: 'AUTO'
    }
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      this.player.log('onPlayerReady', this);
    });

    // this.player.panorama({
    //     maxLat: -10,
    //     initLat: -10,
    //     rotateX: -Math.PI,
    // });
    this.player.vr({projection: this.projection});
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  methods: {
    changePanoramic() {
      console.log("Change Panoramic")
      this.projection = (this.projection == 'AUTO') ? '360' : 'AUTO'
      this.player.vr({projection: this.projection});
    }
  }
}
</script>